import { render } from "./UploadLoading.vue?vue&type=template&id=1df0b97c"
import script from "./UploadLoading.vue?vue&type=script&lang=js"
export * from "./UploadLoading.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__